'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hide = hide;
exports.show = show;

var _ProgressPopupReducer = require('../reducers/ProgressPopupReducer');

var _ProgressPopupReducer2 = _interopRequireDefault(_ProgressPopupReducer);

var _progresspopup = require('../constants/progresspopup');

var _progresspopup2 = _interopRequireDefault(_progresspopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  timeout: 10,
  visible: false
};

exports.default = new _ProgressPopupReducer2.default({
  constants: _progresspopup2.default,
  initialState: initialState
}).reducer;
function hide() {
  return {
    type: _progresspopup2.default.HIDE
  };
}

function show(_ref) {
  var text = _ref.text,
      title = _ref.title,
      timeout = _ref.timeout;

  var options = { text: text, title: title, timeout: timeout };
  return {
    type: _progresspopup2.default.SHOW,
    options: options
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/progresspopup.js
// module id = 531
// module chunks = 1